<div formGroupName="features">
    <!-- Shipment Form -->
    <app-section-header
        class="mt-3"
        [title]="sectionDescription.title"
        [description]="sectionDescription.description"
    ></app-section-header>
    <mat-radio-group formControlName="typeFlow" aria-label="Select an option">
        <mat-radio-button value="shipmentForm">Allow Shipment Form</mat-radio-button>
        <mat-radio-button value="searchForm">Allow Search Payments</mat-radio-button>
    </mat-radio-group>
    <div class="mb-3">
        @if (typeFlow.value === 'searchForm') {
            <app-search-form
                [formGroup]="searchFormGroup"
                [features]="otherFeatures"
                [removeShadowControl]="featuresFormGroup.controls.removeShadow"
            ></app-search-form>
        } @else {
            <app-shipment-form
                [formGroup]="shipmentFormGroup"
                [isEdition]="isEdition"
                [features]="otherFeatures"
                [removeShadowControl]="featuresFormGroup.controls.removeShadow"
            ></app-shipment-form>
        }
    </div>
    <!-- Landing Page Settings -->
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header class="section-panel-header">
            <mat-panel-title class="fw-normal">
                <app-section-header
                    [title]="landingPageSettingsDescription.title"
                    [description]="landingPageSettingsDescription.description"
                ></app-section-header>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mb-3">
            <mat-slide-toggle id="enable-dark-mode" formControlName="enableDarkMode">
                Enable Dark Mode
            </mat-slide-toggle>
        </div>

        <div class="mb-3">
            <mat-slide-toggle id="show-breadcrumbs" formControlName="showBreadcrumbs">
                Show Breadcrumbs
            </mat-slide-toggle>
        </div>
        <div class="mb-3">
            <app-footer-section></app-footer-section>
        </div>
        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Footer Logo Width</mat-label>
                    <input matInput id="footer-logo-width" placeholder="100px" formControlName="footerLogoWidth" />
                    @if (footerLogoWidthControl.invalid && footerLogoWidthControl.hasError('required')) {
                        <mat-error>
                            <app-invalid-field
                                [field]="'footerLogoWidth'"
                                [messageList]="featureSectionErrors['footerLogoWidth']"
                            ></app-invalid-field
                        ></mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Footer Logo Height</mat-label>
                    <input matInput placeholder="100px" id="footer-logo-height" formControlName="footerLogoHeight" />
                    @if (footerLogoHeightControl.invalid && footerLogoHeightControl.hasError('required')) {
                        <mat-error>
                            <app-invalid-field
                                [field]="'footerLogoHeight'"
                                [messageList]="featureSectionErrors['footerLogoHeight']"
                            ></app-invalid-field
                        ></mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Welcome Title</mat-label>
            <input matInput id="welcome-title" formControlName="welcomeTitle" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Welcome Subtitle</mat-label>
            <input id="welcome-subtitle" matInput formControlName="welcomeSubtitle" />
        </mat-form-field>
        <app-facility-information />
    </mat-expansion-panel>
</div>
